(function () {
  if (window.__PM_HEADER_CART_BADGE_INIT) return;
  window.__PM_HEADER_CART_BADGE_INIT = true;

  var MAX = 99;
  var formatting = false;
  var lastDisplayCount = null;

  function enabledProperty(value) {
    return value === true || String(value || '').trim().toLowerCase() === 'true';
  }

  function displayCountForCart(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      var fallback = parseInt(cart && cart.item_count, 10);
      return isFinite(fallback) && fallback > 0 ? fallback : 0;
    }

    return cart.items.reduce(function (count, item) {
      if (!item) return count;
      var properties = item.properties || {};
      var buildId = String(properties._build_id || '').trim();
      var isLinkedPabAccessory =
        !!buildId && enabledProperty(properties._pab_accessory_line);
      if (isLinkedPabAccessory) return count;

      var isPabBuild = !!buildId && enabledProperty(properties._custom_build);
      if (isPabBuild) return count + 1;

      var quantity = parseInt(item.quantity, 10);
      return count + (isFinite(quantity) && quantity > 0 ? quantity : 0);
    }, 0);
  }

  function displayFor(count) {
    var n = parseInt(count, 10);
    if (!isFinite(n) || n <= 0) return '';
    if (n > MAX) return MAX + '+';
    return String(n);
  }

  function tierFor(count) {
    var n = parseInt(count, 10);
    if (!isFinite(n) || n <= 0) return '';
    if (n > MAX) return 'large';
    if (n > 9) return 'pill';
    return 'circle';
  }

  function applyBadge(el, count) {
    if (!el) return;
    var n = parseInt(count, 10);
    if (!isFinite(n)) n = 0;
    var display = displayFor(n);
    var tier = tierFor(n);
    lastDisplayCount = n;

    formatting = true;
    el.setAttribute('data-header-cart-count', display);
    el.dataset.headerCartCount = display;
    el.setAttribute('data-header-cart-count-raw', String(n));
    el.classList.toggle('visible', n > 0);
    el.classList.remove(
      'site-header-cart--count--circle',
      'site-header-cart--count--pill',
      'site-header-cart--count--large',
      'cart-count-badge--circle',
      'cart-count-badge--pill',
      'cart-count-badge--large',
      'site-header-cart--count--single',
      'site-header-cart--count--double',
      'site-header-cart--count--capped'
    );
    if (tier) {
      el.classList.add('site-header-cart--count--' + tier);
      el.classList.add('cart-count-badge--' + tier);
      if (tier === 'large') {
        el.classList.add('site-header-cart--count--capped');
        el.classList.add('cart-count-badge--capped');
      }
    }
    formatting = false;
  }

  function applyCustomerFacingCount(el, cart) {
    var count = displayCountForCart(cart);
    applyBadge(el, count);
    document.querySelectorAll('[data-atc-banner-cart-button]').forEach(function (btn) {
      btn.textContent = 'View Cart & Checkout';
    });
  }

  function boot() {
    var el = document.querySelector('[data-header-cart-count]');
    if (!el) return;

    var raw = el.getAttribute('data-header-cart-count-raw');
    if (raw != null && raw !== '') {
      applyBadge(el, raw);
    } else {
      var display = el.getAttribute('data-header-cart-count') || '';
      applyBadge(el, display === MAX + '+' ? MAX + 1 : display);
    }

    new MutationObserver(function () {
      if (formatting) return;
      var attr = el.getAttribute('data-header-cart-count') || '';
      if (lastDisplayCount !== null && attr !== displayFor(lastDisplayCount)) {
        applyBadge(el, lastDisplayCount);
        return;
      }
      if (attr === MAX + '+') {
        if (!el.classList.contains('site-header-cart--count--large')) {
          applyBadge(el, MAX + 1);
        }
        return;
      }
      var n = parseInt(attr, 10);
      if (!isFinite(n) || n <= 0) return;
      var expectedTier = tierFor(n);
      var hasTier = el.classList.contains('site-header-cart--count--' + expectedTier);
      if (attr !== displayFor(n) || !hasTier) {
        applyBadge(el, n);
      }
    }).observe(el, { attributes: true, attributeFilter: ['data-header-cart-count'] });

    window.addEventListener('cartcount:update', function (event) {
      if (
        event &&
        event.detail &&
        typeof event.detail.item_count !== 'undefined'
      ) {
        applyCustomerFacingCount(el, event.detail);
      }
    });
  }

  window.PMCartDisplayCount = displayCountForCart;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
